/**
 * Base Tab class that will be the superclass of all the tab sub objects.
 * @param: jquery expression for "this" tab
 * @param: jquery expression for "this" container that contains the content of the tab.
 * @param: forms is an array of form names, for each tab. For the submission of that tab that specific form would be called. Seperate out the form names with only 1 space.
 *          eg: "form-name1 form-name2 form-name3"
 * @param: tabOrdinal is the identification of the tab at the back end with number. Used for making ajax calls with types.
 * @param: tabName is the name of the tab which will identify it for the google analytics.
 */

var JV = window.JV || {};

function Tabs( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    this.tab = tabJqueryId;
    this.tabOrdinal = tabOrdinal;
    this.tabName = tabName;
    this.tabUrl = JV.DETAILS_AJAX_URL;
    this.tabAction = "getTab";
    this.tabActiveClass = "active";
    //For not supporting pagination.
    this.pageNum = -1;
    // trying to use the same class for sub tabs. "activeTabObject" object will not work for subtabs.
    this.ifNotSubTab = true;
    //this.isActive = false;
    this.container = $(containerJqueryId);
    var _forms = forms.split(" ");

    var _isActive = false;
    var _isDirty = false;
    var _isDetailsReload = false;
    var _isResumeUpload = false;

    this.getActive = function getActive(){
        return _isActive;
    };

    this.setActive = function setActive( activeState ){
        _isActive = !!activeState;
    };
    this.getDirty = function getDirty(){
        return _isDirty;
    };

    this.setDirty = function setDirty( dirty ){
        _isDirty = !!dirty;
    };
    
    this.getDetailsReload = function getDetailsReload(){
        return _isDetailsReload;
    };

    this.setDetailsReload = function setDetailsReload( detailsReload ){
        _isDetailsReload = !!detailsReload;
    };
    
    this.getResumeUpload = function getResumeUpload(){
        return _isResumeUpload;
    };

    this.setResumeUpload = function setResumeUpload(resumeUpload){
        _isResumeUpload = !!resumeUpload;
    };

    // created for each instance instead of sharing it will all the instances.
    this.getForms= function getForms(){
        return _forms;
    };
}

function toggleAccordionIcon(x) {
    var iconElement = x.querySelector('.jv-toggle-accordion');
    if (iconElement) {
        iconElement.classList.toggle("icon-add");
        iconElement.classList.toggle("icon-close");
    }
}

function isVarNullOrUndefined(val) {
    return (val !== undefined || val != null) ? true : false;
}

function expandAllAccordion(x) {
    if (x.type === 'MESSAGE') {
        var allDomEle = document.getElementById('jv-contactMessagesTab');
    } else if(x.type === 'NOTE') {
        var allDomEle = document.getElementById('jv-contactNotesTab');
    }
    var allElementAccordion = allDomEle.getElementsByClassName('jv-toggle-accordion');
    for (var i = 0; i < allElementAccordion.length; i++) {
        allElementAccordion[i].classList.remove("icon-add");
        allElementAccordion[i].classList.add("icon-close");
    }
}

function closeAllAccordion(x) {
    if (x.type === 'MESSAGE') {
        var allDomEle = document.getElementById('jv-contactMessagesTab');
    } else if(x.type === 'NOTE') {
        var allDomEle = document.getElementById('jv-contactNotesTab');
    }
    var allElementAccordion = allDomEle.getElementsByClassName('jv-toggle-accordion');
    for (var i = 0; i < allElementAccordion.length; i++) {
        allElementAccordion[i].classList.add("icon-add");  
        allElementAccordion[i].classList.remove("icon-close");
    }
}

Tabs.prototype = (function(){

    return {

        /**
         * By default when the page loads the isDirty is false for details.
         * @param {Object} ifDirty
         */
        initialize: function( ifDirty ){
            this.setDirty( !!ifDirty );
            this.attachEvents();    
            return this;
        },

        bindNonLiveEvent: function(){

        },
        /**
         * Activates this tab. Shows the container for the tab and activates teh tab.
         */
        activate: function( content, pageNum ){
            // show the tab active.
            $(this.tab).addClass(this.tabActiveClass);
            if( this.getActive() && !this.getDirty() ){
                // its already active no use of firing active events again.
                return;
            }
            var me = this;
            // if dirty make the ajax call.
            // make sure the active tab object is null.
            if( this.ifNotSubTab){
                if( JV.Person.activeTabObject !==  null ){
                    JV.Person.activeTabObject.deactivate();
                }
                JV.Person.activeTabObject = this;
            }
            
			if( this.getResumeUpload() ){
				this.setResumeUpload(false);
				window.location=window.location.href;
	    	}
			if(!this.getDirty() && this.getDetailsReload()){
				me.activateSubTabs( );
			}
            if( this.getDirty() ){
                //TODO: show the loading state, make ajax call to query the backend for getting the new data.
                // Do not change the _isDirty flag untill you receive the response from the backend. Only after the confirmation from the backend. Change the dirty flag to false.
                this.showLoading().getTab( function( content ){
                    if(me.tabName === "MESSAGES_TAB"){
                        content = content.replace(/stylesheet/g, '');
                    }
                    me.activate( content );
                    me.bindNonLiveEvent();
                    me.activateSubTabs( );
                }, this.pageNum);
                return;
            }
            this.removeLoading();
            this.setActive( true );
            if( !!content && isVarNullOrUndefined(content) && content.trim() !== ""){
                this.container.html(content);
            }
            // remove the hide class from the container. //TODO: need to add some cool animation for its transformation.
            this.container.removeClass("jv-hide");
            this.afterRender();
            // check for the dirty flag here, before you start displaying.
            this.setDetailsReload(false);
            return this;
        },

        /**
         * As some of the tabs make explicit ajax calls to load other portions of the tabs.
         * so put your ajax calls here.
         */
        activateSubTabs: function(){

        },

        /**
         * Put the logic here if you want something to be done when the tab has been fully loaded.
         * Use in place of callbacks after the content is loaded.
         */
        afterRender: function(){

        },


        /**
         * Deactivates this tab.
         */
        deactivate: function(){
            // no use of deactivating a tab if its already not active.
            if( !this.getActive() ){
                return;
            }

            // make the tab inactive.
            $(this.tab).removeClass(this.tabActiveClass);
            this.setActive( false);
            if (this.ifNotSubTab) {
                // if dirty make the ajax call.
                JV.Person.activeTabObject = null;
            }
            // add the hide class from the container. //TODO: need to add some cool animation for its transformation.
            this.container.addClass("jv-hide");
            return this;
        },

        /**
         * Shows the loading state for this tab.
         */
        showLoading: function(){
            $("#jv-loadingContainer").removeClass("jv-hide");
            return this;
        },

        /**
         * remove the loading state for this tab.
         */
        removeLoading: function(){
            $("#jv-loadingContainer").addClass("jv-hide");
            return this;
        },

        getContactId: function(){
            return $("#contactIds").val();
        },

        getContainer: function(){
            return this.container;
        },

        getTab: function( callback, pageNum ){
            var contactId = this.getContactId();
            if(!contactId){
                JV.Util.log("no contact Id available.");
                return;
            }
            var _index = $("#index").val();
            var args = { };
            var data = {
                action: this.tabAction,
                ids: contactId,
                //index: _index,
                types: this.tabOrdinal,
                ifSubTab: !this.ifNotSubTab,
                page: pageNum
            };
            args.url = this.tabUrl;
            args.data = data;
            args.ajaxType = this.tabName;
            var me = this;
            args.success = function (content){
                // after you receive the contents, set the dirty flag to false.
                me.setDirty( false );
                callback( content );
            };
            JV.Util.makeAjaxRequest(args);
        },

        /**
         * This should only be called if we see that the flag is dirty for the tab. It makes an ajax call and refetches the data from the backend.
         */
        fetchData: function(){
            //TODO: after the data is fetched set the dirty flag to false and
            //TODO: then again call the activate so that it can display the contents of the container.
            return this;
        },

        /**
         * returns if the this tab is active.
         */
        getIfActive: function(){
            return isActive;
        },


        /**
         * If required to bound any events. Not sure if we need that.
         */
        attachEvents: function(){
            var me = this;
            $(this.tab).off('click');
            $(document).on('click', this.tab, function() {
                me.activate();
            });
            // Click on tab event binding.
            return this;
        },

        // Updates the tab count.
        /**
         *
         * @param {Object} ifIncrement: if true then increments the count.
         * @param {Object}
         *  @param {ifNotCountContainers}: If true it will not count the number of message containers inside the tab container.
         */
        updateTabCount: function( ){
            JV.Person.loadTabs( );
        },

        /**
         * submission
         */
        submit: function ( formName, callback ){
            // only submit the form available within the container for the tab. Do not submit the form if it has not been registered and
            //is available only to other tabs. In that way we bound the form to that particular container only.
            var me = this;

            if(!callback){
                // nullify the callback if there is nothing available.
                callback = function(){};
            }
        },

        genericAjaxRequest: function( dataObj, callback, errorCallback, ajaxUrl ){
            var args = {};
            args.success = function(content){
                !!callback? callback(content): function(){};
            };
            args.error = function(content){
                !!errorCallback? errorCallback(content): function(){};
            };
            args.url = !!ajaxUrl? ajaxUrl: this.tabUrl;
            args.data = dataObj;
            args.ajaxType = dataObj.action;
            JV.Util.makeAjaxRequest(args);
        },

        showLoadingOnTask: function( parentRef){
            return JV.Util.showLoadingProcess(parentRef);
        },

        getEmptyTmpl: function( type,ifNoHeading ){
            if(!type){
                return "";
            }
            var _tmpl = ["<h3>", type, "</h3>", JV.Person.Const["NO_ACTIVITY"].format( type.toLowerCase())];
            return ifNoHeading? _tmpl[3]: _tmpl.join("");
        }
    };
})();

/**
 * Details Tab
 */
function DetailsTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName, jqApplicationContainer, jqCampaignsContainer, jqHistoryContainer, jqShareContainer, jqStatusContainer, jqNewTagsContainer){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName);
    this.jqAppContainerId = jqApplicationContainer;
    this.jqCampContainerId = jqCampaignsContainer;
    this.jqHistContainerId = jqHistoryContainer;
    this.jqShareContainerId = jqShareContainer;
    this.jqStatusContainerId = jqStatusContainer;
    this.jqNewTagsContainerId = jqNewTagsContainer;
}

JV.Util.extend(DetailsTab, Tabs);

DetailsTab.prototype.initialize = function(dirtyFlag){
    this.superclass.initialize.apply(this,[dirtyFlag]);
    this.activateSubTabs(); 
    if(!dirtyFlag && isSocialProfileEnabled){
        this.initLinkedIn();
    }
};

DetailsTab.prototype.activateSubTabs = function(){
    this.superclass.activateSubTabs.apply(this);
    this.getStatusHistory();
    this.getApplications();
    this.getCampaigns();
    this.getCandidateHistory();
    this.getShareHistory();
};

DetailsTab.prototype.attachEvents = function(){
    this.superclass.attachEvents.apply(this);

    $(document).on('click','ul.jv-scrollFix li', function(){
        var $block = null;
        switch($(this).attr('id')){
            case 'jv-FM-DetailsMenu':
                $("li#jv-FM-linkedIn, li#jv-FM-twitter, li#jv-FM-google").addClass('jv-hide');
                $('ul.jv-scrollFix').css({"position":"absolute"});
                $("li#jv-FM-socialProfiles").removeClass('active');
                $("li#jv-FM-DetailsMenu").addClass('active');
                $block = $('div#jv-details').find('div#jv-contactInformation');     
                break;
            case 'jv-FM-socialProfiles':
                $("li#jv-FM-socialProfiles").addClass('active');
                $("li#jv-FM-DetailsMenu").removeClass('active');
                $('ul.jv-scrollFix .jv-hide').removeClass('jv-hide');
                $('ul.jv-scrollFix').css({"position":"fixed","top":"0"});
                $block = $('div#jv-details').find('div#jv-contactSummaryTab');      
                break;
            case 'jv-FM-linkedIn':
                $("li#jv-FM-linkedIn").addClass('active');
                $("li#jv-FM-twitter, li#jv-FM-google").removeClass('active');
                $block = $('div#jv-details').find('div#jv-linkedInWidget');     
                break;
            case 'jv-FM-twitter':
                $("li#jv-FM-twitter").addClass('active');
                $("li#jv-FM-linkedIn, li#jv-FM-google").removeClass('active');
                $block = $('div#jv-details').find('div.jv-twtr-soc-wid');       
                break;
            case 'jv-FM-google':
                $("li#jv-FM-google").addClass('active');
                $("li#jv-FM-twitter, li#jv-FM-linkedIn").removeClass('active');
                $block = $('div#jv-details').find('div.jv-goog-soc-wid');       
                break;
        }           
        
        $('html, body').animate({
            scrollTop : $block ? $block.offset().top : 0
        }, 500);
        $(document).scroll(function() {
                if (window.pageYOffset > 120) {
                    $('ul.jv-scrollFix').css({"position":"fixed","top":"0"});
                } else {
                    $('ul.jv-scrollFix').css({"position":"absolute","top":"0"});
                }
            });
    });
    
    
    $(document).on('click','ul.jv-hList li[TYPE="DETAIL"]', function(){
        $(this).removeClass("jv-clickable");
        var key = $(this).attr("KEY");
        var reverse_key = $(this).attr("REVERSE_KEY");
        var type = $(this).attr("TYPE");

        $('[TYPE="DETAIL"][key="'+key+'_CONTAINER"]').removeClass("jv-hide");
        $('ul.jv-hList li[key="'+key+'"]').removeClass("jv-clickable");

        $('[TYPE="DETAIL"][key="'+reverse_key+'_CONTAINER"]').addClass("jv-hide");
        $('ul.jv-hList li[key="'+reverse_key+'"]').addClass("jv-clickable");

        if(JV.TempPerson === null){
            //TODO: add the version number.
            $.getScript("/__assets__/scripts/source/person/JV.AddContact.js", function(){
                JV.TempPerson.initialize();
            });
        }
        if(key === JV.Person.Const['EDIT']){
            $("#jv-contactSummaryTab").addClass("jv-hide");
            $(".jv-detailEdit").addClass("jv-hide");
        }else{
            $("#jv-contactSummaryTab").removeClass("jv-hide");
            $(".jv-detailEdit").removeClass("jv-hide");
        }
        
    });

    $(document).on("click keydown", "*[KEY='CANCEL']", function(e) {
        if (e.type === "click" || e.which === 13) { // Check if it's a click event or Enter key press
            $("#jv-listJobIds").val("");
        }
    });

    $("#sendMessageForm, #addTaskForm, #addNoteForm").on('change', "input, textarea, select", function() {
        $(this).closest('form').addClass('enterEditMode');
    });
    

    $(document).on('keydown keyup','#tagInputs_annoninput .maininput', function() {
        $(this).closest('form').addClass('enterEditMode');
    });
    $(document).on('keydown keyup', '#tagInputs_annoninput .maininput', function() {
        $(this).closest('form').addClass('enterEditMode');
    });
    $(window).on('beforeunload', function(event) {
        if($(".enterEditMode").length !== 0){
            event.preventDefault();
            return '';
        }
    });

    var me = this;
    //For Candidate History navigation.
    $(document).on('click', "li[TYPE='HISTORY'][KEY='PREVIOUS'], li[TYPE='HISTORY'][KEY='NEXT']", function() {
        var _page = $(this).attr("page");
        me.getCandidateHistory( _page );
    });
    
    $(document).on('click', "li[TYPE='CAMPAIGN'][KEY='PREVIOUS'], li[TYPE='CAMPAIGN'][KEY='NEXT']", function(){
        var _page = $(this).attr("page");
        me.getCampaigns( _page );
    });
    
    $(document).on('click', "li[TYPE='STATUS_HISTORY'][KEY='PREVIOUS'], li[TYPE='STATUS_HISTORY'][KEY='NEXT']", function(){
        var _page = $(this).attr("page");
        me.getStatusHistory( _page );
    });
    
    $(document).on('click', "li[TYPE='APPLICATIONS'][KEY='PREVIOUS'], li[TYPE='APPLICATIONS'][KEY='NEXT']", function(){
        var _page = $(this).attr("page");
        me.getApplications( null, _page );
    });

    
    //VA: main contact details navigation for the contacts.
    $(document).on('click', "li[TYPE='CONTACT_NAVIGATION'][KEY='PREVIOUS'], li[TYPE='CONTACT_NAVIGATION'][KEY='NEXT']", function(){
        var key = $(this).attr("KEY");
        var activeTabOrdinal = $('li.active').attr("ordinal");
        var activeTabOrdinalVal = (activeTabOrdinal == 1)?"":"&activeTabOrdinal="+activeTabOrdinal;
        var index = _contactIds.indexOf(JV.CONTACT_IDS);
        if(index==-1){
            return;
        }
        var id = null
        switch(key){
            case "PREVIOUS":
                id= _contactIds[index-1]    
                break;
            case "NEXT":
                id= _contactIds[index+1]
                break;      
        }
        if(typeof id=="undefined"){
            return;
        }
        var form = document.createElement("form");
        form.id = "temporaryJobviteForm";
        form.method = "post";
        form.action = window.location.href.split("?")[0] +"?ids=" + id +activeTabOrdinalVal;
        var input = document.createElement("input");
        $(input).attr("name","contactIds")
        $(input).attr("value", _contactIds);
        
        var input2 = document.createElement("input");
        $(input2).attr("name","totalContactIds")
        $(input2).attr("value", _totalContactIds);
        
        $(input).appendTo(form);
        $(input2).appendTo(form);
        
        document.body.appendChild(form);
        $('#temporaryJobviteForm').trigger('submit');
        
        
        // find if that is previous or next
        //find the next/previous id in the _contactIds
        // create url post it to the contact navigation form.
        // 
        // present contact id.
        
//      var _page = parseInt($(this).attr("page"), 10);
//      $("#jv-contactNavigation").find("input[name='index']").val( _page+1 );
//      $("#jv-contactNavigation").find("input[name='activeTabOrdinal']").val(JV.Person.activeTabObject.tabOrdinal);
//      //window.location.reload(true);
//      $("#jv-contactNavigation").submit();

    });

    $(document).on('click', "span[TYPE='REMOVE_CAMPAIGN']", function(){
        var _campaignId = $(this).attr("KEY");
        me.removeCampaign( _campaignId);
    });

    $(document).on('click', "#jv-deleteCampaign", function(){
        var keyV = $(this).attr("key");
        var element = $('.jv-campaignRemove[KEY='+keyV+']');
        const _campaignId = $("#jv-deleteCampaign").attr("KEY");
        var _parentRef = $(element).closest("div[KEY='PARENT']").length ? $(element).closest("div[KEY='PARENT']"):$(element).closest("ul[KEY='PARENT']");
        me.confirmedRemoveCampaign(_campaignId, _parentRef);
    });
    
    $(document).on('click', ".jv-countRecepient", function(){
        $('.jv-shareInfo').addClass('jv-hide');
        var element = $(this).closest('.hr-sectionEntity').children('.jv-shareInfo');
        $(element).removeClass('jv-hide');
    });
    
    $(document).on('click', ".jv-close2", function(){
        $(this).closest('.jv-shareInfo').addClass("jv-hide");
    });
};

/* ===========================================================================
    getApplications
    * @param <int> readMode
    ========================================================================== */
DetailsTab.prototype.getApplications = function(readMode, page) {
    var data = {
        action: "getApplications",
        ids: this.getContactId(),
        page: !!page? page: 0
    };
    var callbacks = this.attachAjaxCallbacks( this.jqAppContainerId);

    if (typeof(readMode) === 'number' && readMode !== undefined) {
        data.readmode = readMode;
    }
    this.genericAjaxRequest( data, callbacks._callback, callbacks._errorCallback);
};

/* ===========================================================================
    getApplications
    * @param <int> readMode
    ========================================================================== */
DetailsTab.prototype.getShareHistory = function(readMode){
    var self = this;
    var ajaxURL = null;
    var containerID = self.jqShareContainerId;
    var data = {
        action: "getShareHistory",
        ids: self.getContactId(),
        page: -1
    };
    var callbacks;

    if (!JV.IS_SEAT) {
        return;
    }

    if (typeof(readMode) === 'number' && readMode !== undefined) {
        ajaxURL = '/TalentNetwork/action/person/contactDetailsPage';
        containerID = 'div[TYPE="DETAIL"][KEY="SHARE_HISTORY"]';
        data.readmode = readMode;
    }

    callbacks = self.attachAjaxCallbacks(containerID);

    this.genericAjaxRequest( data, callbacks._callback, callbacks._errorCallback, ajaxURL);
};

DetailsTab.prototype.getCampaigns = function(page){
    if (!JV.IS_SEAT) {
        return;
    }
    const data = {
        action: "getCampaigns",
        page: !!page? page: 0,
        ids: this.getContactId()
    };
    var callbacks = this.attachAjaxCallbacks( this.jqCampContainerId);
    this.genericAjaxRequest( data, callbacks._callback, callbacks._errorCallback);
};

DetailsTab.prototype.showConfirmation =  function(message, campaignId){
    var template = '<div class="jv-dialog-top jv-roundTop jqHandle jqDrag" > \
                        <span class="jv-dialog-title">' + i18n['JV_CONTACTDETAILS_DELETE'] + '</span>\
                        <span class="jv-closeModalDialog" KEY="CANCEL"></span>\
                    </div>\
                    <div class="jv-modalWrapper clearfix" style="width:503px" id="jv-removeCampaign">\
                        <div class="jv-dialog-content">\
                        <div id="jv-confirmMessage">'+ message +
                        '</div>\
                        <div class="jv-buttonContainer">\
                             <span  style="margin-right:10px;" class="jv-buttonWrapper jv-importClass jv-buttonWrapperCancel" KEY="CANCEL" tabIndex="2">\
                                 <ul>\
                                    <li class="jvdb-left-light custom_li">\
                                    </li>\
                                    <li class="jvdb-center-light  custom_li">\
                                        ' + i18n['JV_CONTACTDETAILS_CANCEL'] + '\
                                    </li>\
                                    <li class="jvdb-right-light custom_li">\
                                    </li>\
                                </ul>\
                            </span>\
                            <span id="jv-deleteCampaign" KEY='+campaignId+' style="float:right;" class="jv-buttonWrapper" tabIndex="1">\
                                <ul>\
                                    <li class="jvdb-left custom_li">\
                                    </li>\
                                    <li class="jvdb-center custom_li">\
                                            ' + i18n['JV_CONTACTDETAILS_DELETE'] + '\
                                    </li>\
                                    <li class="jvdb-right custom_li">\
                                    </li>\
                                </ul>\
                            </span>\
                       </div>\
                     </div>\
                 </div>\
                 <div class="jv-dialog-bottom" style="width:503px"></div>';
    JV.Modal.show(template);
    
}

DetailsTab.prototype.removeCampaign = function( campaignId){
    this.showConfirmation(JV.Person.Const['DELETE_CONFIRMATION'], campaignId);
}

DetailsTab.prototype.confirmedRemoveCampaign = function( campaignId, parentRef ){
    const data = {
        "action": "doRemoveFromCampaign",
        "campaignIds":  campaignId,
        "ids":  this.getContactId()
    };
    var _callback = function( content ){
        $(parentRef).remove( );
        JV.Modal.hide();
        // change the message for the campaign portion if there are no campaigns left.
        var sectionContentContainer = $("div[KEY='CAMPAIGNS'][TYPE='DETAIL'] .jv-sectionDetail");
        if( $(sectionContentContainer).children().length <= 1 ){
            $(sectionContentContainer).html(JV.Person.Const["NO_CAMPAIGN"]);
        }
    };
    var me = this;
    var _errorCallback = function( args ){
        me.getCampaigns( );
    };

    this.genericAjaxRequest( data, _callback, _errorCallback, JV.AJAX_URL);
};

DetailsTab.prototype.getCandidateHistory = function(page) {
    if (!JV.IS_SEAT) {
        return;
    }
    const data = {
        action: "getCandidateHistory",
        page: !!page? page: 0,
        ids: this.getContactId()
    }
    var callbacks = this.attachAjaxCallbacks( this.jqHistContainerId);

    this.genericAjaxRequest( data, callbacks._callback, callbacks._errorCallback);
};


DetailsTab.prototype.getStatusHistory = function(page) {
    if (!JV.IS_SEAT || !JV.ENABLE_HRTECH_UI) {
        return;
    }
    const data = {
        action: "getContactStatusHistory",
        page: !!page? page: 0,
        ids: this.getContactId()
    }
    var callbacks = this.attachAjaxCallbacks( this.jqStatusContainerId);

    this.genericAjaxRequest( data, callbacks._callback, callbacks._errorCallback);
};

DetailsTab.prototype.attachAjaxCallbacks = function( jqContainer ){
    var _callback = function( content ){
        $(jqContainer).html(content).removeClass("jv-hide");
    };
    var _errorCallback = function( content ) {
        if (content.status == 400) {
            $(jqContainer).html("");
            $(jqContainer).addClass("jv-hide");
        }
    };
    return {
        "_callback": _callback,
        "_errorCallback": _errorCallback
    };
};

DetailsTab.prototype.initLinkedIn = function() {
    if (!_liMap.application.candidate) {
        return;
    }
    //initialize the init script for LinkedIn.
    var contact = _liMap.application.candidate;
    contact.emailAddress = contact.email;
    contact.customerId = contact.EId;
    contact.id = contact.linkedInId;
    contact.nodeId = contact.linkedInInfoId;
    document.initLinkedIn(contact.EId, null, $('#LIScript'),contact,LIAPIKey);
    $('#jv-linkedInWidget').removeClass('jv-hide');
};

/**
 * Resume Tab
 */
function ResumeTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName);
    if(JV && !JV.FileUploader){     
        $.getScript("/__assets__/scripts/source/person/JV.fileUploaderHelper.js", function(){       
            JV.FileUploader.init({      
                allowedExtensions:[],       
                multiple: true      
            });     
        });     
    }   
}
JV.Util.extend(ResumeTab, Tabs);
ResumeTab.prototype.attachEvents = function(){
    this.superclass.attachEvents.apply(this);
    var me = this;
    $(document).on('click', "div[KEY='RESUME'] .jv-uploadFiles", function(){
        JV.Modal.render({
            "action": "getFileUpload",
            "url": me.tabUrl
        });
    });
    
    $(document).on('click','select.jv-fileKind', function(e){
        if($(this).val() !== JV.Person.Const["RESUME"]) {
            $("#jv-mergeCheckUpload").addClass("jv-hide");
        } else {
            $("#jv-mergeCheckUpload").removeClass("jv-hide");
        }
    });
    
    $(document).on('click', 'select.jv-pasteFileKind', function(e){
        if($(this).val() !== JV.Person.Const["RESUME"]) {
            $("#jv-mergeCheckPaste").addClass("jv-hide");
        } else {
            $("#jv-mergeCheckPaste").removeClass("jv-hide");
        }
    });
    
    $(document).on('click', "*[KEY='ATTACHMENT_DOWNLOAD']", function(e){
        e.stopPropagation();
    });
    
    $(document).on('click', "*[TYPE='RESUME']", function(e){
        var _key = $(this).attr("KEY");
        var _parent = $(this).closest("div[KEY='PARENT']");
        switch(_key){
            case "HEADER":
                var _next = $(this).next();
                $(_next).fadeToggle();
                var _imgRef = $(this).find("img[KEY='ICON']");
                var ifHasMinusClass = $(_imgRef).hasClass("jv-minusIcon")? true: false;
                if(ifHasMinusClass){
                    $(_imgRef).removeClass("jv-minusIcon");
                }else{
                    $(_imgRef).addClass("jv-minusIcon");
                }
                break;
            case "DELETE":
                var _taskId = $(_parent).attr("ACTIVITY");
                me.bringDeleteFileConfirmationBox(_taskId);
                return false;
                break;
            default:
            JV.Util.log("some unknown event")
        }
    });
}

ResumeTab.prototype.bringDeleteFileConfirmationBox = function( attachmentId ){
    var dataObj = {
        "action": "getDeleteConfirmation",
        "contactAttributeIds": attachmentId,
        "ids": this.getContactId()
    }
    var _callback = function( content ){
        JV.Modal.show( content);
    };
    this.genericAjaxRequest( dataObj, _callback, null);
}

ResumeTab.prototype.DeleteFile = function(attachmentId){
    var dataObj = {
        "action": "doRemoveAttachment",
        "contactAttributeIds": attachmentId,
        "ids": this.getContactId()
    }
    var _callback = function(){
        $("#jv-contactResumeTab div[ACTIVITY='"+ attachmentId +"']").remove( );
        var parent = $("#jv-contactResumeTab").find(".jv-sectionHeader");
        var rows = $(parent).find(".jv-messageContainer");
        var length = $(rows).length;
        if(length==0){
            //$(parent).find(".jv-messageContainer");
            //$(".jv-messageContainer").addClass("jv-hide");
            //parent.append('<p>Test</p>');
            //$(".jv-uploadFiles").addClass("jv-hide");
            $(".jv-borderAll").addClass("jv-hide");
            var _tmpl = [
                         "<div id='jv-candidateDetail'>",
                         "<div class='jv-sectionHeader'>" + JV.Person.Const["CONTACT_ZERO_ATTACHMENT"] +
                         "</div>",
                         "</div>"

                        ]
            parent.append( _tmpl.join("") );
        }
    }
    this.genericAjaxRequest( dataObj, _callback, null);
}

/**
 * Message Tab
 */
function MessageTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName);
}
JV.Util.extend(MessageTab, Tabs);
MessageTab.prototype.attachEvents = function(){
    this.superclass.attachEvents.apply(this);
    $(document).on('click', "*[TYPE='MESSAGE']", function(){
        var _key = $(this).attr("KEY");
        switch(_key){
            case "EXPAND":
                $("div[TYPE='MESSAGE'][KEY='DETAIL']").each(function(){
                    $(this).slideDown();
                });
                $("*[TYPE='MESSAGE']").find("img[KEY='ICON']").addClass("jv-minusIcon");
                break;
            case "CLOSE":
                $("div[TYPE='MESSAGE'][KEY='DETAIL']").each(function(){
                    $(this).slideUp();
                });
                $("*[TYPE='MESSAGE']").find("img[KEY='ICON']").removeClass("jv-minusIcon");
                break;
            case "HEADER":
                var _next = $(this).next();
                $(_next).fadeToggle();
                //VA: This below code is repeated multiple times. Future cleanup is to make it reusable.
                var _imgRef = $(this).find("img[KEY='ICON']");
                var ifHasMinusClass = $(_imgRef).hasClass("jv-minusIcon")? true: false;
                if(ifHasMinusClass){
                    $(_imgRef).removeClass("jv-minusIcon");
                }else{
                    $(_imgRef).addClass("jv-minusIcon");
                }
                break;
        case "SUMMARY":
            var _next = $(this).next();
                $(_next).fadeToggle();
            var _nextNext = _next.next();
            _nextNext.fadeToggle();

                //VA: This below code is repeated multiple times. Future cleanup is to make it reusable.
                var _imgRef = $(this).find("img[KEY='ICON']");
                var ifHasMinusClass = $(_imgRef).hasClass("jv-minusIcon")? true: false;
                if(ifHasMinusClass){
                    $(_imgRef).removeClass("jv-minusIcon");
                }else{
                    $(_imgRef).addClass("jv-minusIcon");
                }
            break;
            default:
            JV.Util.log("some unknown event")
        }
    });
}

/**
 * Notes Tab
 */
function NotesTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName)
}
JV.Util.extend(NotesTab, Tabs);
NotesTab.prototype.attachEvents = function(){
    this.superclass.attachEvents.apply(this);
    var me = this;
    $(document).on('click', "*[TYPE='NOTE']", function(){
        var _key = $(this).attr("KEY");
        var _parentTemp = $(this).parentsUntil("div[KEY='PARENT']");
        var _parentDiv = $( _parentTemp[ _parentTemp.length -1 ] ).parent();
        $(_parentDiv).find(".jv-errorMessage").html( "" );
        switch(_key){
            case "EXPAND":
                $("div[TYPE='NOTE'][KEY='DETAIL']").each(function(i){
                    $(this).slideDown();
                });
                $("*[TYPE='NOTE']").find("img[KEY='ICON']").addClass("jv-minusIcon");
                break;
            case "CLOSE":
                $("div[TYPE='NOTE'][KEY='DETAIL']").each(function(){
                    $(this).slideUp( );
                });
                $("*[TYPE='NOTE']").find("img[KEY='ICON']").removeClass("jv-minusIcon");
                break;
            case "HEADER":
                var _next = $(this).next( );
                $(_next).fadeToggle();
                var _imgRef = $(this).find("img[KEY='ICON']");
                var ifHasMinusClass = $(_imgRef).hasClass("jv-minusIcon")? true: false;
                if(ifHasMinusClass){
                    $(_imgRef).removeClass("jv-minusIcon");
                }else{
                    $(_imgRef).addClass("jv-minusIcon");
                }
                break;
            case "NOTE_EDIT":
                var children = $(_parentDiv).children( );
                var taskId = _parentDiv.attr("ACTIVITY");
                JV.Person.accordianObjects[1].doEdit( taskId,{
                    "textarea": $(children[0]).find("textarea").val()
                })
                $("#jv-notes .jv-open").addClass("hide");
                $("#jv-notes").addClass("open");
                $("#jv-sidebar").addClass("open");
                    // in-box editing. 
                    // var children = $(_parentDiv).children( );
                    //          // Make the clone of the edit container and append it at the end. When the user cancels the edit. Take it and put it as the first child.
                    //          var clone = $(children[0]).clone();
                    //          // add the datepicker on the clone.
                    //          $(_parentDiv).append( clone );  // third child of the parent with index 2
                    //          // Edit container.
                    //          $(children[0]).removeClass("jv-hide");
                    //          // content container.
                    //          $(children[1]).addClass("jv-hide");
                                    
                break;
            case "NOTE_DELETE":
                var taskId = _parentDiv.attr("ACTIVITY");
                me.showLoadingOnTask( _parentDiv );
                // It is the last note that would be removed.
                var _showEmptyMessage = ($(me.container).find(".jv-messageContainer").length == 1);
                var _callback = function(){
                    me.removeTaskFromUI( _parentDiv );
                    me.updateTabCount( );
                    JV.Util.showMessage(JV.Person.Const["NOTE_DELETE_SUCCESS"]);
                    if(_showEmptyMessage){
                        $(me.container).find(".jv-sectionHeader").html( me.getEmptyTmpl(JV.Person.Const["NOTES"]) );
                    }
                }
                me.deleteNote(taskId, _callback);
                var border = $(this).closest(".jv-borderAll");
                if($(border).children().length == 2){
                    $(border).addClass("jv-hide");
                }
                break;
            case "NOTE_CANCEL":
                    var children = $(_parentDiv).children( );
                    // clone added at the top.
                    $(children[0]).before( $(children[2] ) );
                    // Edit container.
                    $(children[0]).remove();
                    // content container.
                    $(children[1]).removeClass("jv-hide");
                break;
            case "NOTE_SAVE":
                var note = $(_parentDiv).find(".jv-textarea").val();
                //validate
                if( note === undefined || note === null || note.trim() === "" ){
                    $(_parentDiv).find(".jv-errorMessage").html( JV.Person.Const["EMPTY_VALUE"] );
                    return;
                }
                var taskId = _parentDiv.attr("ACTIVITY");
                var tempdiv = me.showLoadingOnTask( _parentDiv );
                var _callback = function( content ){
                    try{
                        // backend can send some error, check if the input was valid.
                        var obj = eval('('+ content +')')
                        $(_parentDiv).find(".jv-errorMessage").html( obj.error );
                    }catch(e){
                        $(_parentDiv).html(content);
                    }
                    // remove the loading modal on the task.
                    $(tempdiv).remove();
                    JV.Person.loadTabs( );
                };
                me.saveNote( taskId, _callback, note);
                break;
            default:
                JV.Util.log("some unknown event")
        }
    });
}

NotesTab.prototype.removeTaskFromUI = function( parentDiv ){
    parentDiv.slideUp('fast', function(){
        parentDiv.remove();
    });
};

NotesTab.prototype.deleteNote = function(taskId, callback){
    var data = {
        "action": "doDeleteNote",
        "contactAttributeIds":taskId,
        "ids": this.getContactId()
    }
    this.genericAjaxRequest( data, callback);
};

NotesTab.prototype.saveNote = function( taskId, callback, note ){
    var data = {
        "action": "doEditNote",
        "contactAttributeIds":taskId,
        "ids": this.getContactId(),
        "type": "Contact",
        "message": note

    }
    this.genericAjaxRequest( data, callback);
};

/**
 * Tags is not a form but a div, so it needs a special treatment.
 * @param {Object} formName
 * @param {Object} associatedTabObject: null in this case.
 * @param {Object} jqtagsContainer
 */
function TagAccordian(formName, associatedTabObject, jqtagsContainer ){
    Accordian.call(this, formName, associatedTabObject, null, null);
    this.jqtagsContainer = $(jqtagsContainer);
}

JV.Util.extend(TagAccordian, Accordian);
TagAccordian.prototype.attachEvent = function(){
    this.superclass.attachEvent.call(this);
    var me = this;
    $(this.jqtagsContainer).fcbkcomplete({
                    json_url: JV.AJAX_URL,
                    height: 10,
                    addontab: true,
                    addoncomma: true,
                    newel: true,
                    //limit: 2,
                    preventFunctionKeys: true,
                    action: "getTagsWithPrefix",
                    caption: "name",
                    identifier: "id"
                });
    this.cancel();
    //VA: After the initialization move the input to the end of the tag list. For some reason it appears at the
    $(".holder").append($("#tagInputs_annoninput"));
    //VA: Also when someone clicks anywhere on the div. Bring the focus to the holder.
    $(document).on('click', "#tags_tagsinput", function(){
        $("#tagInputs_annoninput input").focus( ).css("border","1px solid #ccc");
    }) ;
    $("#tagInputs_annoninput input").blur( function(){
        //$(this).val("");
        $(this).css("border","none");
    });

}

TagAccordian.prototype.submit = function(){
    var _tags = [ ];
    $(".holder span").each(function(){
        _tags.push( $(this).text() );
    });
    var data = {
        "action": "doSaveTags",
        "type":"Contacts",
        "ids": $("#contactIds").val(),
        tagNames: _tags
    }

    if(data.tagNames.length === 0) {
        data.tagNames = '';
    }
    var args = { };
    args.url = JV.DETAILS_AJAX_URL;
    args.data = data;
    args.ajaxType = data.action;
    var me = this;
    args.success = function(){
        $("form#"+me.formName).removeClass('enterEditMode');
        me.close();
        // After the save, add the
        $(".jv-tagsHolder").html( $(".holder").html());
        $(".jv-tagsHolder #tagInputs_annoninput").remove( );

        JV.Util.log("Updated");
        JV.Util.showMessage(JV.Person.Const["TAGS_SAVE_SUCCESS"]);
        /*
        if(!!me.associatedTabObject){
            for (var i =0 ; i < me.associatedTabObject.length ; i++){
                me.associatedTabObject[i].setDirty(true);
                if( me.associatedTabObject[i] === JV.Person.activeTabObject){
                    me.associatedTabObject[i].activate( );
                }
            }
            //me.close();
        }
        */

        $(".jv-addedTags").html("");
        for( var i=0,j=_tags.length; i<j; i++){
            if(i != 0){
                $(".jv-addedTags").append(", ");
            }
            $(".jv-addedTags").append( $("<div></div>").text(_tags[i]).html() );
        };

    };
    JV.Util.makeAjaxRequest(args);
}

TagAccordian.prototype.cancel = function(){
    $("form#"+this.formName).removeClass('enterEditMode');
    $(".holder .bit-box").remove( );
    // For tags which were saved before.
    var element = $(".holder").children();
    $(element).before($(".jv-tagsHolder").html());
    // adding events to those tags.
    $(".closebutton").click(function(){
        $(this).parent().remove();
    });
}

TagAccordian.prototype.open = function(){
    this.superclass.open.call(this);
    $(".jv-addedTags").css("display","none");
}

TagAccordian.prototype.close = function(){
    this.superclass.close.call(this);
    $(".jv-addedTags").css("display","block");
}

/**
 * Tasks Tab
 */
function TasksTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName)
}

JV.Util.extend(TasksTab, Tabs);

TasksTab.prototype.getTab = function(functionCallback, pageNumber){
    //VA: Mongo based check.
    if( $("#addTaskForm").find("input[name='entityType']").length == 1){
        var template = "<iframe marginheight='no' marginwidth='no' frameborder='no' scrolling='no' horizontalscrolling='no' verticalscrolling='no' style='overflow: hidden' border='0' width='1000px'  src='" + JV.BASE_URL+"task/list.html?noHeader=true&entityType=Contact&entityIds="+this.getContactId()+"' />";
        this.setDirty(false);
        this.activate( template );
    }else{
        this.superclass.getTab.call(this, functionCallback, pageNumber);    
    }
}

TasksTab.prototype.afterRender = function(){
    this.superclass.afterRender.call(this);

    // the container is not available until the data gets loaded.
    this.completeTab = new Tabs("li[TYPE='TASK'][KEY='COMPLETE_TAB']", "#jv-completeTasksContainer","", null, "COMPLETE_TAB");
    this.completeTab.initialize(true);
    this.completeTab.tabAction = "getCompletedTasks"
    // this is for keeping track of the parent object
    this.completeTab.parentRef = this;
    //TODO: need to fill it.
    this.completeTab.tabActiveClass = "subTabActive";
    // trying to use the same class for sub tabs. "activeTabObject" object will not work for subtabs.
    this.completeTab.ifNotSubTab = false;

    // the container is not available until the data gets loaded.
    this.openTab = new Tabs("li[TYPE='TASK'][KEY='OPEN_TAB']", "#jv-openTasksContainer","", 5, "OPEN_TAB");
    this.openTab.initialize(false);
    //this.openTab.tabAction = "getTabs"
    this.openTab.parentRef = this;
    this.openTab.tabActiveClass = "subTabActive";
    this.openTab.ifNotSubTab = false;
    //this.openTab.setDirty(false);
    this.openTab.setActive(true);
}

TasksTab.prototype.attachEvents = function(){
    var me = this;
    this.superclass.attachEvents.apply(this);
    var args = {};
    args.success = function(content){
        $("input.jv-datePicker").each(function() {
            var altName = "#" + $(this).attr('name').replace( /(:|\.|\[|\]|,)/g, "\\$1" ) + "-alt";
            $(this).datepicker({
                altField: altName,
                altFormat: 'mm/dd/yy',
                dateFormat: window._jvselfUser.locale.userDate.shortDatePicker() || 'mm/dd/yy',
                changeMonth: true,
                changeYear: true,
                showOn:"both",
                buttonImage: '/__assets__/images/icon-calendar.png', 
                buttonImageOnly: true,
            });
        });
    }

    args.type = 'GET';
    args.url = JV.TIME_ZONE_URL;
    $.ajax( args );

    $(document).on('click', "*[TYPE='TASK']", function(){
        var _key = $(this).attr("KEY");
        var _parentTemp = $(this).parentsUntil("div[KEY='PARENT']");
        var _parentDiv = $( _parentTemp[ _parentTemp.length -1 ] ).parent();
        $(_parentDiv).find(".jv-errorMessage").html( "" );
        switch(_key){
            case "EXPAND":
                $("div[TYPE='TASK'][KEY='DETAIL']").each(function(i){
                    $(this).slideDown();
                });
                $("*[TYPE='TASK']").find("img[KEY='ICON']").addClass("jv-minusIcon");
                break;
            case "CLOSE":
                $("div[TYPE='TASK'][KEY='DETAIL']").each(function(){
                    $(this).slideUp();
                });
                $("*[TYPE='TASK']").find("img[KEY='ICON']").removeClass("jv-minusIcon");
                break;
            case "HEADER":
                var _next = $(this).next();
                $(_next).fadeToggle();
                var _imgRef = $(this).find("img[KEY='ICON']");
                var ifHasMinusClass = $(_imgRef).hasClass("jv-minusIcon")? true: false;
                if(ifHasMinusClass){
                    $(_imgRef).removeClass("jv-minusIcon");
                }else{
                    $(_imgRef).addClass("jv-minusIcon");
                }
                break;
            case "TASK_EDIT":
                var taskId = _parentDiv.attr("ACTIVITY");
                var children = $(_parentDiv).children( );
                JV.Person.accordianObjects[2].doEdit( taskId, {
                    "input[type='text']": $(children[0]).find("input").val(),
                    "textarea": $(children[0]).find("textarea").val()
                });
                break;
            case "TASK_CANCEL":
                    var children = $(_parentDiv).children( );
                    // clone added at the top.
                    $(children[0]).before( $(children[2] ) );
                    // Edit container.
                    $(children[0]).remove();
                    //add the datepicker to the new clone object.
                    $(children[2]).find(".jv-datePicker").attr("id","").removeClass("hasDatepicker").datepicker({
                        changeMonth: true,
                        changeYear: true,
                        buttonImage: "/__assets__/images/icon-calendar.png",
                        buttonImageOnly: true
                    });
                    // content container.
                    $(children[1]).removeClass("jv-hide");

                break;
            case "TASK_SAVE":
                var date = $(_parentDiv).find(".jv-datePicker").val();
                var note = $(_parentDiv).find(".jv-textarea").val();
                //validate
                if( (date === undefined || date === null || date.trim() == "") || (note === undefined || note === null || note.trim() == "") ){
                    var message = (date === undefined || date === null || date.trim() == "") ? JV.Person.Const["INVALID_DATE"]:JV.Person.Const["EMPTY_VALUE"];
                    $(_parentDiv).find(".jv-errorMessage").html( message );
                    return;
                }
                var taskId = _parentDiv.attr("ACTIVITY");
                var tempdiv = me.showLoadingOnTask( _parentDiv );
                var _callback = function( content ){
                    try{
                        // backend can send some error, check if the input was valid.
                        var obj = eval('('+ content +')')
                        $(_parentDiv).find(".jv-errorMessage").html( obj.error );
                    }catch(e){
                        $(_parentDiv).html(content);
                    }
                    // remove the loading modal on the task.
                    $(tempdiv).remove();
                    JV.Person.loadTabs( );
                };
                me.saveTask( taskId, _callback, date, note);
                break;
            case "TASK_DELETE":
                var taskId = _parentDiv.attr("ACTIVITY");
                me.showLoadingOnTask( _parentDiv );
                var tabCountKey = me.completeTab.getActive()? "COMPLETE" : "OPEN";
                var _activeTab = me.completeTab.getActive() ? me.completeTab: me.openTab;
                var _showEmptyMessage = ($(_activeTab.container).find(".jv-messageContainer").length == 1);
                var _callback = function(){
                    me.removeTaskFromUI( _parentDiv );
                    me.updateSubTabCount( tabCountKey, false, false );
                    me.updateTabCount( );
                    JV.Util.showMessage(JV.Person.Const["TASK_DELETE_SUCCESS"]);
                    if(_showEmptyMessage){
                        $(_activeTab.container).html( me.getEmptyTmpl(JV.Person.Const[tabCountKey+"_TASKS"], true) );
                    }
                }
                me.deleteTask(taskId, _callback);
                break
            case "TASK_COMPLETE":
                //get the reference to the container.
                var taskId = _parentDiv.attr("ACTIVITY");
                me.showLoadingOnTask( _parentDiv );
                var status = true;
                var tabCountKey = "OPEN";
                if( me.completeTab.getActive() ){
                    status = false;
                    me.openTab.setDirty(true);
                    // Instead of setting the dirty on the openTab set it on the root tab.
                    //me.setDirty(true)
                    tabCountKey = "COMPLETE";
                }else{
                    me.completeTab.setDirty(true);
                }
                var _activeTab = me.completeTab.getActive() ? me.completeTab: me.openTab;
                var _showEmptyMessage = ($(_activeTab.container).find(".jv-messageContainer").length == 1);
                var _callback = function(){
                    me.removeTaskFromUI(_parentDiv);
                    me.updateSubTabCount( tabCountKey, true, false );
                    JV.Util.showMessage(JV.Person.Const["TASK_UPDATE_SUCCESS"]);
                    JV.Person.loadTabs( );
                    if(_showEmptyMessage){
                        $(_activeTab.container).html( me.getEmptyTmpl(JV.Person.Const[tabCountKey+"_TASKS"], true) );
                    }
                }
                me.completeTask( taskId ,_callback, status);
                break;
            case "COMPLETE_TAB":
                // deactivate the open tab
                me.openTab.deactivate();
                break;
            case "OPEN_TAB":
                // deactivate the complete tab
                me.completeTab.deactivate();
                break;
            default:
                JV.Util.log("some unknown event");
        }
    });
}


/**
 * Opens a given task with a given taskId(activity ID)
 * @param {Object} activityId
 */
TasksTab.prototype.openTaskWithId = function( activityId ){
    $("*[activity='"+ activityId +"']").find("ul.jv-messageHeader[type='TASK']").click()
}

/**
 * This gets called only when the tab gets reloaded again.
 */
TasksTab.prototype.bindNonLiveEvent = function( ){
    this.superclass.bindNonLiveEvent.apply(this);
    $("div[TYPE='TASK'] .jv-datePicker" ).datepicker({
        changeMonth: true,
        changeYear: true,
        buttonImage: "/__assets__/images/icon-calendar.png",
        buttonImageOnly: true
    });
};

TasksTab.prototype.showLoadingOnTask = function( parentRef){
    var tempdiv = $("<div>").css({
                        "height": parentRef.height()+10,
                        "width": parentRef.width()+10,
                        "top":"-5px",
                        "left":"-5px",
                        "position":"absolute"
                    });
    //_parentDiv.parent().append( tempdiv );
    $(tempdiv).addClass("alpha60");
    parentRef.append(tempdiv);
    return tempdiv;
};

TasksTab.prototype.removeTaskFromUI = function( parentDiv ){
    parentDiv.slideUp('fast', function(){
        parentDiv.remove();
    });
};

TasksTab.prototype.deleteTask = function( taskId, callback ){
    data = {
        action: "doDeleteTask",
        contactAttributeIds: taskId,
        ids: this.getContactId( )
    }
    this.genericAjaxRequest( data, callback);
};

/**
 * Takes care of the subtab counts for the TasksTab
 * @param {Object} tabCountKey: which Tab to take action on ->  "COMPLETE" or "OPEN"
 * @param {Object} ifToggle: if the counts should toggle between the subtabs.
 * @param {Object} ifIncrement: if the action is to increment the count value or decrement the count value.
 */
TasksTab.prototype.updateSubTabCount = function( tabCountKey, ifToggle, ifIncrement ){
    var countRef = $("span[TYPE='TASK'][KEY='"+ tabCountKey +"_COUNT']");
    var count = parseInt(countRef.text( ));
    if( ifToggle ){
        var key = tabCountKey == "OPEN"? "COMPLETE" : "OPEN";
        var otherCountRef = $("span[TYPE='TASK'][KEY='"+ key +"_COUNT']");
        var otherCount = parseInt( otherCountRef.text( ) );
        otherCount = (ifIncrement && otherCount > 0 )? otherCount - 1 : otherCount + 1 ;
        otherCountRef.text( otherCount );
    }
    count = ( !ifIncrement && count > 0 ) ? count -1 : count+1;
    countRef.text( count );
};



TasksTab.prototype.saveTask = function( taskId, callback, endDate, notes){
    data = {
        "action": "doEditTask",
        "contactAttributeIds":  taskId,
        "endDate": endDate,
        "ids": this.getContactId(),
        "notes": notes,
        "type": "Contact"
    };
    this.genericAjaxRequest( data, callback);
}

/**
 * @param {String} taskId: task on which the action took place.
 * @param {Function} callback: function callback
 * @param {Boolean} status: true when moving to complete otherwise false.
 */
TasksTab.prototype.completeTask = function( taskId, callback, status ){
    data = {
        "action": "doCompleteTask",
        "contactAttributeIds": taskId,
        "ids": this.getContactId(),
        "isCompleted": status
    }
    this.genericAjaxRequest( data, callback);
}


/**
 * New class for the side bar.
 */
function Accordian( formName, associatedTabObject, addActionName, editActionName ){
    this.editAction = editActionName;
    this.addAction = addActionName;
    this.formName = formName;
    this.parent = $("form#"+formName).parentsUntil("li[KEY='PARENT']").parent();
    this.formParent = $(this.parent).children()[1]
    this.header = $(this.parent).children()[0]
    this.associatedTabObject = associatedTabObject;
    this.icon = $(this.header).find("img");
    this.state = 0; // 1 is for open. 0 is for close
    this.mode = "ADD"   // 'EDIT' is another mode
}

Accordian.prototype = (function(){
    return {

        initialize: function(){
            this.attachEvent();
        },

        // If we are updating the activity rather then updating it.
        update: function( activityId ){

        },

        /**
         * Show error about empty fields.
         */
        validateBeforeSubmit: function(){
            var _error = false;
            var _inputs = $("#"+this.formName).find("input[type='text']");
            var _textareas = $("#"+this.formName).find("textarea");
            // Remove the class if it preexist
            $(_inputs).removeClass("jv-borderRed");
            $(_textareas).removeClass("jv-borderRed");
            var errorCall = function errorCall( reference ){
                if( $(reference).val() === undefined || $(reference).val() === null || $(reference).val().trim() == ""){
                    _error = true;
                    $(reference).addClass("jv-borderRed");
                }
            }
            // Input fields.
            _inputs.each(function( ){
                errorCall( this );
            });
            // Textarea fields.
            _textareas.each(function( ){
                errorCall( this );
            })
            return _error;
        },

        // change the context of the right bar to the edit mode.
        doEdit: function( taskId, typeObj){
            for(var object in typeObj){
                // eg. "input[type='text']" or "textarea"
                $("#"+this.formName).find( object ).val( typeObj[object] )
            }
            // change the action to the edit action.
            $("#"+ this.formName+" input[name='action']").val(this.editAction);
            // set the task id.
            $("#"+this.formName+" input[type='hidden'][name='contactAttributeIds']").val( taskId );
            $(this.parent).find( "span[KEY='DRAFT']" ).text( "("+ JV.Person.Const["DRAFT"] + ")" );
            if( JV.Person.activeAccordianObject !== this && JV.Person.activeAccordianObject != null){
                JV.Person.activeAccordianObject.close();
            }
            this.open();
            this.mode = "EDIT";
        },

        submit: function(){
            var me = this;
            var mode = me.mode;
            if(this.validateBeforeSubmit()){
                $("#"+this.formName).find(".jv-error").text( JV.Person.Const["EMPTY_VALUE"] );
                return false;
            };
            var overlayer = this.associatedTabObject[0].showLoadingOnTask( $($("#"+this.formName).closest("li")[0]) );
            
            var ajaxURL = (this.mode == 'EDIT')? JV.DETAILS_AJAX_URL:null;
            //VA: There are two modes for tasks, so check if the due date is present. If the due date is present in the task form that means it will be saved to mongodb, change the url then.
            if(this.formName == "addTaskForm" && this.mode !== "EDIT" && $("#"+this.formName).find("input[name='entityType']").length == 1 ){
                ajaxURL = JV.TASKS_URL + "/save"
            }
            
            //VA: the last argument for submitForm is necessary as the edits are done at a different url, otherwise the calls will break.
            JV.Person.submitForm(this.formName,function(){
                overlayer.remove();
                $("#"+me.formName).removeClass('enterEditMode');
                    JV.Util.log("Updated");
                    if(!!me.associatedTabObject){
                        for (var i =0 ; i < me.associatedTabObject.length ; i++){
                            
                            if($(me.associatedTabObject[i]).attr("tabName")==="DETAILS_TAB" ){
						   		me.associatedTabObject[i].setDetailsReload(true);
                                if($(JV.Person.activeTabObject).attr("tabName")==="DETAILS_TAB"){
                                	JV.Person.activeTabObject.getCandidateHistory();
                                }
                            }
                            else{
                                me.associatedTabObject[i].setDirty(true);
                                if( me.associatedTabObject[i] === JV.Person.activeTabObject){
                                    me.associatedTabObject[i].activate( );
                                }

                            }

                        }

                        me.cancel();
                        me.close();
//                      var accordian_element = me.parent.attr("type");
                        var accordian_element = me.parent[0].getAttribute("type");
                        if(accordian_element=="MESSAGE"){
                            JV.Util.showMessage(JV.Person.Const["MESSAGES_SEND_SUCCESS"]);
                        }
                        if(accordian_element=="TASKS"){
                            if(mode=="ADD"){
                                JV.Util.showMessage(JV.Person.Const["TASK_ADD_SUCCESS"]);
                            }
                            if(mode=="EDIT"){
                                JV.Util.showMessage(JV.Person.Const["TASK_EDIT_SUCCESS"]);
                            }
                        }
                        if(accordian_element=="NOTES"){
                            if(mode=="ADD"){
                                JV.Util.showMessage(JV.Person.Const["NOTE_ADD_SUCCESS"]);
                            }
                            if(mode=="EDIT"){
                                JV.Util.showMessage(JV.Person.Const["NOTE_EDIT_SUCCESS"]);
                            }
                        }
                    }
                    JV.Person.loadTabs( );
                    // success
                }, function(){
                    JV.Util.log("Something went wrong in updating");
                    // failure.
                }, ajaxURL);
                // submit here.
        },

        attachEvent: function(){
            var me = this;
            $(document).on('keyup', "#"+this.formName+" textarea", function(){
                var li = $(this).closest("li");
                if($(this).val() === undefined || $(this).val() === null || $(this).val().trim() == ""){
                    $(li).find( "span[KEY='DRAFT']" ).text("");
                }
                else{
                    $(li).find( "span[KEY='DRAFT']" ).text( "("+ JV.Person.Const["DRAFT"] + ")" );
                }

            });
            
            $(document).on('click', "input:checkbox[name=jv-jobId]", function(e){
                var jobListArray= [];
                var jobListIds = "";
                if(isVarNullOrUndefined($("#jv-listJobIds").val()) && $("#jv-listJobIds").val().trim() != "")
                    var jobListArray = $("#jv-listJobIds").val().split(',');
            
                if ($(this).is(':checked')){
                    if(isVarNullOrUndefined($(this).val()) && $(this).val().trim() !=""  &&  $.inArray( $(this).val() , jobListArray) === -1){
                        var value = $("#jv-listJobIds").val() + ((isVarNullOrUndefined($("#jv-listJobIds").val()) && $("#jv-listJobIds").val().trim() != "")?",":"")+$(this).val();
                        $("#jv-listJobIds").val(value);
                    }
                }else{
                    if(isVarNullOrUndefined($(this).val()) && $(this).val().trim() !="" && $.inArray( $(this).val() , jobListArray) !== -1){
                        jobListArray.splice( jobListArray.indexOf($(this).val()), 1);
                        $("#jv-listJobIds").val(jobListArray.join(','));
                    }
                }
            });

            $("#"+this.formName+" span[KEY='ACCORDIAN_CANCEL']").on("click", function(){
                me.cancel();
            });
            $("#"+this.formName+" span[KEY='ACCORDIAN_SUBMIT']").on("click", function(){
                me.submit();
            });
            $(this.header).on("click", function(e){
                e.preventDefault();
                if( !!JV.Person.activeAccordianObject && me !== JV.Person.activeAccordianObject ){
                    JV.Person.activeAccordianObject.close();
                }
                var action =  me.state ? "close" : "open";
                me[action]();
            });
            
            
        },

        close: function(){
            if(!_HRTECHUI_ENABLED){
                $(this.formParent).slideUp('fast');
                $(this.icon).removeClass("jv-minusIcon");   
                this.state=0;
                JV.Person.activeAccordianObject = null;
            }else{
                    var ref = $("form[name='"+this.formName +"']").closest('li');
                    ref.removeClass('open').addClass("close");
                    setTimeout(function(){
                        ref.removeClass("close")
                        ref.children('.jv-open').removeClass('hide');
                        $('#jv-sidebar').removeClass('open');
                    },400);
            }

            
        },

        /**
         * Brings it back to the default case of add
         */
        cancel: function(){
            $("#"+this.formName).removeClass('enterEditMode');
            $("#"+this.formName).find("input[type='text']").val("").removeClass("jv-borderRed");
            $("#"+this.formName).find("textarea").val("").removeClass("jv-borderRed");
            $("#"+this.formName).find(".jv-error").text("");
            // changes the form back to the add mode
            $("#"+this.formName+" input[type='hidden'][name='action']").val( this.addAction );
            $("#"+this.formName+" input[type='hidden'][name='contactAttributeIds']").val( "" );
            // Also remove the task ids from the form. because it might have been filled because of the action.
            $(this.parent).find("span[KEY='DRAFT']").text("");
            this.mode = "ADD";
        },

        open: function(){
            if (!_HRTECHUI_ENABLED) {
                $(this.formParent).slideDown('fast');   
                $(this.icon).addClass("jv-minusIcon");
                this.state=1;
                JV.Person.activeAccordianObject = this;
            }

        }
    }
})()


/**
 * Same params as the Accordian. For HR UI it needs to bind event for select2 also.
 * @param {Object} formName
 * @param {Object} associatedTabObject
 * @param {Object} jqtagsContainer
 * @param {Object} editActionName
 */
function TaskAccordian(formName, associatedTabObject, jqtagsContainer, editActionName ){
    Accordian.call(this, formName, associatedTabObject, jqtagsContainer, editActionName );
}

JV.Util.extend(TaskAccordian, Accordian);
TaskAccordian.prototype.attachEvent = function(){
    this.superclass.attachEvent.call(this);
    
    // select 2 event needs to be binded.
    if(_HRTECHUI_ENABLED){
        var config = $.extend({}, window._jvPluginDefaults.select2, {
            placeholder: i18n["JV_CONTACTDETAILS_SELECT_EMPLOYEE"],
            minimumInputLength: 1,
            ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
                url: jvUrls.admin + '/action/user/search',
                dataType: 'json',
                // object that backend needs
                data: function( term ){
                    return {
                        pageSize: 10,
                        q: term
                    };
                },
                results: function (data, page) { // parse the results into the format expected by Select2.
                    // since we are using custom formatting functions we do not need to alter remote JSON data
                    return {results: data.employees};
                }
            },
            formatResult: function(item){
                return item.fullName;
            },
            id: function(item){
                return item.EId;
            },
            formatSelection: function(item){
                return item.fullName;
            },
            dropdownCss: {
                position: 'fixed' // positioning is not correct without this
            }
        });
        $("#jv-employee").select2(config);

        // enable disable the select.
        $("#jv-assTOSome").on('click', function(){
            if( $(this).prop("checked")){
                $("#jv-selectContainer").show();
            }else{
                $("#jv-selectContainer").hide();
            }
        });

        // When the page scrolls remove the select2. It needs to reposition itself after the scroll.
        $(document).on('scroll', function(){
            $("#jv-employee").select2("close");
        });
    }
}

TaskAccordian.prototype.validateBeforeSubmit = function(){
    if (!_HRTECHUI_ENABLED) {
        this.superclass.validateBeforeSubmit.call(this);
        return; 
    }
    var _error = false;
    //var _inputs = $("#"+this.formName).find("input[type='text']");
    var _inputs = $([$("#jv-taskEndDate").get(0)]);
    var _textareas = $("#"+this.formName).find("textarea");
    // Remove the class if it preexist
    $(_inputs).removeClass("jv-borderRed");
    $(_textareas).removeClass("jv-borderRed");
    var errorCall = function errorCall( reference ){
        if( $(reference).val() === undefined || $(reference).val() === null || $(reference).val().trim() == ""){
            _error = true;
            $(reference).addClass("jv-borderRed");
        }
    }
    // Input fields.
    _inputs.each(function( ){
        errorCall( this );
    });
    // Textarea fields.
    _textareas.each(function( ){
        errorCall( this );
    })
    return _error;
}


/**
 * Tasks Tab
 */
function VideoTab( tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName ){
    Tabs.call(this, tabJqueryId, containerJqueryId, forms, tabOrdinal, tabName)

}

JV.Util.extend(VideoTab, Tabs);

// Add the hash functionality which is specific to video tab only.
VideoTab.prototype.bindNonLiveEvent = function(){
    // var scope = $("body").scope();
    // window.location.hash="#/videos/897"
    // //scope.$compile(angular.element("#videoTabView"))
    // debugger;
    // scope.$apply();
    // scope.$apply(function(){
        
    // });
}

VideoTab.prototype.attachEvents = function(){
    var me = this;
    $(this.tab).off('click');
    $(document).on('click', this.tab, function() {
        me.activate();
    });
    // Click on tab event binding.
    return this;
}

VideoTab.prototype.getDirty = function(){
    return false;
}

VideoTab.prototype.getTab = function(callback){
    //For video the content is all in the DOM already when it loaded. 
    //So just have to show it.
    this.removeLoading();
    window.location.hash = "/videos/23432";
    this.container.removeClass("jv-hide");
}




JV.TempPerson = {
    /**
     * Array of all the tab objects.
     */
    tabObjects: [ ],
    accordianObjects:[ ],
    /**
     * active tab object referene/pointer.
     */
    activeTabObject: null,
    activeAccordianObject:null,

    initialize: function(){
        var _details = null;
        var _message = null;
        var _notes = null;
        var _task = null;
        this.attachEvent();
        //VA: Details Tab expect three more parameters, even though it still inherits from the Tabs class.
        // The extra parameters are the containers for the
        // applications, campaigns, history and tags for the contact.
        
        this.tabObjects.push(_details = new DetailsTab( "li[TYPE='TAB'][KEY='DETAILS']" , "div[TYPE='CONTAINER'][KEY='DETAILS']", "", 1, "DETAILS_TAB", "div[TYPE='DETAIL'][KEY='APPLICATIONS']", "div[TYPE='DETAIL'][KEY='CAMPAIGNS']", "div[TYPE='DETAIL'][KEY='HISTORY']", "div[TYPE='DETAIL'][KEY='SHARE_HISTORY']", "div[TYPE='DETAIL'][KEY='STATUS_HISTORY']", "div[TYPE='DETAIL'][KEY='TAGS']"));      
        this.tabObjects.push(new ResumeTab( "li[TYPE='TAB'][KEY='RESUME']" , "div[TYPE='CONTAINER'][KEY='RESUME']", "", 2, "RESUME_TAB"));
        this.tabObjects.push(_task = new TasksTab( "li[TYPE='TAB'][KEY='TASKS']" , "div[TYPE='CONTAINER'][KEY='TASKS']", "", 5, "TASKS_TAB"));
        this.tabObjects.push(_notes = new NotesTab( "li[TYPE='TAB'][KEY='NOTES']" , "div[TYPE='CONTAINER'][KEY='NOTES']", "", 3, "NOTES_TAB"));
        this.tabObjects.push( _message = new MessageTab( "li[TYPE='TAB'][KEY='MESSAGES']" , "div[TYPE='CONTAINER'][KEY='MESSAGES']", "", 4, "MESSAGES_TAB") );
        this.tabObjects.push( new VideoTab( "li[TYPE='TAB'][KEY='VIDEOS']" , "div[TYPE='CONTAINER'][KEY='VIDEOS']", "", 6, "VIDEOS_TAB") );
        // We preload the first tab, so it doesn't need the loading state initially.
        var tabInitArray = [false, true, true, true, true, true];
        for( var i = 0, j= this.tabObjects.length; i <j; i++){
            (this.tabObjects[i]).initialize( tabInitArray[i] );
        }
        if(isVarNullOrUndefined(_taskId) && _taskId.trim()){
            (this.tabObjects[2]).activate();
            var taskme = this;
            setTimeout(function(){
                (taskme.tabObjects[2]).openTaskWithId(_taskId);
            }, 500)

        }else{
            var tabObjectsIndex;
            if(_activeTabOrdinal === undefined || _activeTabOrdinal === null || _activeTabOrdinal.trim()==""){
                tabObjectsIndex = 0;
            }
            else{
                for(var i = 0; i < this.tabObjects.length; i++){
                    if(this.tabObjects[i].tabOrdinal == _activeTabOrdinal) {
                        tabObjectsIndex = i;
                    }

                }
            }
            (this.tabObjects[tabObjectsIndex]).activate();
        }


        //Accordian
        this.accordianObjects.push(new Accordian("sendMessageForm", [_message, _details], "doSendMessage"));
        this.accordianObjects.push(new Accordian("addNoteForm", [_notes, _details], "doAddNote","doEditNote"));
        this.accordianObjects.push(new TaskAccordian("addTaskForm", [_task, _details], "doAddTask","doEditTask"));
        for(var i = 0; i < this.accordianObjects.length; i++){
            this.accordianObjects[i].initialize( );
        }

    },
    
    detailsChanged: function(contactChangeLog){
        var updateCount = '';
        var addCount = '';
        var updateSection = $(".jv-updateInfo");
        var addeSection = $(".jv-addInfo");
        updateSection.empty();
        addeSection.empty();
        $(".jv-update").addClass("jv-hide");
        $(".jv-add").addClass("jv-hide");
        
        if(contactChangeLog.nameUpdated){
            updateCount++;
            updateSection.append("<p>"+ JV.Person.Const["NAME"]+ "</p>");
        }
        if(contactChangeLog.addressUpdated){
            updateCount++;
            updateSection.append("<p>"+ JV.Person.Const["ADDRESS"]+ "</p>");
        }
        if(contactChangeLog.jobUpdated){
            updateCount++;
            updateSection.append("<p>"+ JV.Person.Const["JOB"]+ "</p>");
        }
        if(contactChangeLog.primaryEmailChanged){
            updateCount++;
            updateSection.append("<p>" +JV.Person.Const["PRIMARY_EMAIL"]+ "</p>");
        }
        if(contactChangeLog.primaryPhoneNumberChanged){
            updateCount++;
            updateSection.append("<p>" +JV.Person.Const["PRIMARY_PHONE"]+ "</p>");
        }
        if(contactChangeLog.phoneNumberAdded){
            addCount++;
            addeSection.append("<p>" +JV.Person.Const["PHONE"]+ "</p>");
        }
        if(contactChangeLog.emailAdded){
            addCount++;
            addeSection.append("<p>" +JV.Person.Const["EMAIL"]+ "</p>");
        }
        if(updateCount>0) {
            $(".jv-updateCount").text(updateCount);
            $(".jv-update").removeClass("jv-hide");
        }
        if(addCount>0) {
            $(".jv-addCount").text(addCount);
            $(".jv-add").removeClass("jv-hide");
        }
        return updateCount||addCount;
    },
    
    loadTabs: function(){
        // LOADING the tabs again.
        var dataObj = {
            "action": "getTabsHeader",
            "ids": $("#contactIds").val()
        }
        var args = {};
        args.success = function(content){
            $("#jv-contactDetailTabHolder").replaceWith( content );
            JV.Person.activeTabObject.activate( );
        }
        args.error = function(content){
            //document.location = document.location;
        }
        args.url = JV.DETAILS_AJAX_URL;
        args.data = dataObj;
        args.ajaxType = dataObj.action;
        JV.Util.makeAjaxRequest(args);
    },

    addReqCheckEmail: function(){
        if(_HRTECHUI_ENABLED){

            var _firstName = isVarNullOrUndefined($("#jv-firstName").val()) && $("#jv-firstName").val().trim();
            var _lastName = isVarNullOrUndefined($("#jv-lastName").val()) && $("#jv-lastName").val().trim();
            if(_firstName === "" || _lastName === ""){
                JV.Modal.show($("#jv-addReqError").html(),false);
            }else{
                JV.Person.getOverlayJobs(0, null, null,true,31);
            }
        }
        else{
            JV.Person.getOverlayJobs(0, null, null,false);
        }
    },
    
    attachEvent: function(){
        var me = this;
        $(".jv-rating").css({"display":"block"});
        $(".jv-rating").prepend('<div style="float: left">{0}:&nbsp;</div>'.format(i18n['JV_RATING']));
        $(".jv-rating").stars({
            callback: function (ui, type, value) {
                me.saveStarRatingForUser(value);
            }
        });
    },

    saveStarRatingForUser: function(value){
        if(value === undefined || value === null || value.trim() === '' ){
            // dont save without any value
            return;
        }
        var args = {};
        var data = {
            action: "doSaveRatings",
            ids: $("#contactIds").val(),
            rating: value
        }
        args.url = JV.DETAILS_AJAX_URL;
        args.data = data;
        args.ajaxType = "doSaveRatings";
        args.success = function (content){
            JV.Util.showMessage(content);
        };
        JV.Util.makeAjaxRequest(args);
    },

    // Remove the faded tax from the input fields.
    removeFadedText: function(){

    },

    // add the faded text into the input fields.
    addFadedText: function(){

    },


    /**
     * Constructs the iframe on the modal overlay for uploading the resume or coverletter
     */
    onFileUpload: function() {
        var _contactId = $("#contactIds").val();
        $("#importFileUploadContent").removeClass("jv-hide").addClass("jv-show");
        var _frameContents = $("#importFileUploadContent").contents();
        _frameContents.find("body").append($("<form/>", {
            name: 'importUploadFileForm',
            id: 'importUploadFileForm',
            action: JV.IMPORT_FILE_AJAX_URL,
            method: 'post',
            enctype: 'multipart/form-data'
            }).append($("<input/>", {
                type: 'file',
                size: '43',
                style: 'font-size: 12px;',
                id: 'data',
                name: 'data',
                onChange: 'parent.JV.Person.populateNameField()'
            })
        ));
    },

    addRequisitions: function( candidateEid, selectedJobs, data, _callback){
        var args = {};
        args.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded';
        args.traditional = true;
        args.type = 'POST';
        args.dataType = "html";
        args.url = JV.JHIRE_ADD_CANDIDATE;
        var data = {
                candidateEid: candidateEid,
                j: selectedJobs
        };
        args.data = data;
        args.success = function (data){
            _callback();
        };
        $.ajax( args );
    },
    
    populateData: function(data, selectedJobs){
        var FId_EId_Map = new Object();
        var data = eval('('+ data +')');
        var viewFields = data.viewFields;
        var fieldIds= $("input[fieldId]");
        var homePhones= $("input[phtype=HOME]");
        var cellPhones= $("input[phtype=CELL]");
        var workPhones= $("input[phtype=WORK]");
        
        for(var i =0 ; i < viewFields.length ; i++){
            if(viewFields[i].fieldId < 0){
                FId_EId_Map[viewFields[i].fieldId] = viewFields[i].EId;
            }
        }
        var data2 = {
                generalApplication: false,
                j: selectedJobs
        };
        
        $.each( fieldIds, function( index, element ) {
            if(isVarNullOrUndefined($(element).val()) && $(element).val().trim() != ""){
                var fId = $(element).attr("fieldId");
                data2[FId_EId_Map[fId]] = $(element).val();
            }
        });
        
        if(isVarNullOrUndefined(homePhones.val()) && homePhones.val().trim() != ""){
            data2[FId_EId_Map[-8]] = homePhones.val();
        }
        
        if(isVarNullOrUndefined(cellPhones.val()) && cellPhones.val().trim() != ""){
            data2[FId_EId_Map[-9]] = cellPhones.val();
        }
        
        if(isVarNullOrUndefined(workPhones.val()) && workPhones.val().trim() != ""){
            data2[FId_EId_Map[-62]] = workPhones.val();
        }
        
        return data2;
    },
    
    addCandidateAndReq: function(selectedJobs, _callback){
        var me = this;
        var args = {};
        args.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded';
        args.traditional = true;
        args.type = 'GET';
        args.dataType = "html";
        args.url = JV.JHIRE_ADD_CANDIDATE;
        args.success = function (data){
            var data2 = me.populateData(data, selectedJobs);
            
            //Making AJAX call for resume
            
            var args5 = {};
            args5.contentType = 'application/x-www-form-urlencoded';
            args5.type = 'GET';
            args5.url = JV.DETAILS_AJAX_URL;
            args5.data = {
                    action: "getResumeContent",
                    candidateEid: data.candidateEId,
                    ids: $("#contactIds").val()
            };
            args5.success = function (data){
                if(isVarNullOrUndefined(data.resumeText) && data.resumeText.trim() != ""){
                    data2["content"] = data.resumeText;
                }
                data2.contactFileEId = data.contactFileEId;
                data2.contactEId = $("#contactIds").val();
                
                /* Work Status
                if($.trim($("[name=details.workStatusId]").val()) != ""){
                    data2[FId_EId_Map[-10]] = $("[name=details.workStatusId]").val();
                }else if($.trim($("[name=details.workStatus]").val()) != ""){
                    data2[FId_EId_Map[-10]] = $("[name=details.workStatus]").val();
                }*/
                
                
                var args_source = {};
                args_source.contentType = 'application/x-www-form-urlencoded';
                args_source.type = 'GET';
                args_source.url = JV.JHIRE_SOURCE_TYPES;
                args_source.dataType = "html";
                args_source.success = function (data){
                    var data_source = eval('('+ data +')');
                    var sourceTypeInfoArray = data_source.sourceTypes;
                    var _retValue= "";
                    var _selectedSource =  $('select[name="details.sourceTypeId"]').val();
                    var result = $.grep(sourceTypeInfoArray, function(e){return e.name == _selectedSource;}); //Find the sourceTypeInfo object from the array for the current selected source
                    var currectSourceInfoObject = result[0];
                    var _selectedSourceOption = $('select[name="details.sourceTypeId"]').find("option[value='"+_selectedSource+"']");
                    if(_selectedSource !== "Source type"){
                        if (JV.Person.Source.isDetailsSourceType(_selectedSourceOption)) { //Has source details
                            if (JV.Person.Source.isInternalSourceType(currectSourceInfoObject.kind)) { //send user id in this case
                                _retValue = currectSourceInfoObject.EId+"|"+ $('input[name="details.sourceName"]').val();
                            }else if(JV.Person.Source.isAgencySourceType(currectSourceInfoObject.kind)){
                                if(isVarNullOrUndefined($('input[name="details.sourceName"]').val()) && $('input[name="details.sourceName"]').val().trim() != ""){
                                    _retValue = currectSourceInfoObject.EId+"|"+ $('input[name="details.sourceName"]').val() + "|" + $("#jv-sourcedByAgencyEId").val(); //Without this userId it was giving a NPE
                                }else{
                                    _retValue = currectSourceInfoObject.EId;
                                }
                            }
                            else if (isVarNullOrUndefined($('input[name="details.sourceName"]').val()) && $('input[name="details.sourceName"]').val().trim() != "") {
                                _retValue = currectSourceInfoObject.EId + "|" + $('input[name="details.sourceName"]').val();
                            }
                            else{
                                _retValue = currectSourceInfoObject.EId;
                            }
                        } 
                        else {
                            _retValue = currectSourceInfoObject.EId;
                        }
                        data2[data_source.viewFieldEId] = _retValue;
                    }
                    
                    var args2 = {};
                    args2.contentType = 'application/x-www-form-urlencoded';
                    args2.type = 'POST';
                    args2.url = JV.JHIRE_ADD_CANDIDATE;
                    args2.data = data2;
                    args2.success = function (data){
                            var args4 = {};
                            args4.contentType = 'application/x-www-form-urlencoded';
                            args4.type = 'GET';
                            args4.url = JV.DETAILS_AJAX_URL;
                            args4.data = {
                                action: "setCandidateEId",
                                candidateEid: data.candidateEId,
                                ids: $("#contactIds").val()
                            };
                            args4.success = function (data){
                                _callback();
                            }
                            $.ajax(args4);
                    }
                    $.ajax(args2);
                }
                $.ajax(args_source);
            }
            $.ajax(args5);
            
                
        };
        $.ajax( args );
    },
    
    
    addRequisition: function( ids, callback, mode){
        var self = this;
        if(!$(".jv-importClass").prop("disabled")){
            var selectedJobs = $("#jv-listJobIds").val();
            if(selectedJobs === undefined || selectedJobs === null || selectedJobs.trim() === ""){
                var errorType = !!mode? "OFCCP_JOBSELECT_ERROR":"JOBSELECT_ERROR";
                $(".jv-modalWrapper #jv-selectError").html( JV.Person.Const[errorType] );
                return false;
            }
            $(".jv-importClass").prop("disabled",true);
            $("#jv-jobListLoadingStateWrapper").removeClass("jv-hide");
            //JV.Util.showLoadingProcess($("#jv-modalDialog"));
            var candidateEid = $("#candidateEId").val();
            var _callback = !!callback? callback: function(){};
            /*if($.trim(candidateEid) != ""){
                this.addRequisitions(candidateEid, selectedJobs, data, _callback);
            }
            else{*/
                self.addCandidateAndReq(selectedJobs, _callback);
            //}
        }
    },

    process: function( formName, optional, event ){
        var me = this;
        var _modal = JV.Modal;

        switch(formName){
            case "jobForm":
                var _callback = function( content ) {
                    $(".jv-importClass").prop("disabled",false);
                    $("#jv-jobListLoadingStateWrapper").addClass("jv-hide");
                    JV.Modal.hide();
                    (me.tabObjects[0]).getApplications(0);
                    (me.tabObjects[0]).getCandidateHistory();
                    $("#jv-listJobIds").val("");
                };

                if (_HRTECHUI_ENABLED) {
                    me.addRequisition(null, _callback);
                }
                else {
                    me.addToRequisition(null, _callback);
                }
                break;
            
            case "selectPersonForm":     //Only in WEB-INF>pages>applicant>personView.jsp
            case "selectAssignedToPersonForm":
                // would be coming from the add contact page.
                JV.TempPerson.process(formName, optional, event );
                break;
            case "addToCampaignForm":
                var _callback = function( content ){
                    JV.Modal.hide();
                    JV.Util.showMessage( content );
                    (me.tabObjects[0]).getCampaigns();
                    (me.tabObjects[0]).getCandidateHistory();
                };
                this.addToCampaign( _callback );
                break;
            case "uploadFileForm":
                var _fileName = $("#jv-attachmentName").val();
                var _contactId = $("#contactIds").val();
                var _type = $("#jv-fileKind").val( );

                // check for the validation. If the input field is empty.
                var _callback = function(data){
                    try{
                        //alert(me.tabObjects[1]===JV.Person.activeTabObject);
                        obj = eval('('+ data+')');
                        JV.Util.showMessage(obj.confirmationMessage);
                        (me.tabObjects[1]).setDirty(true);
                        if (me.tabObjects[1] === JV.Person.activeTabObject) {
                            me.tabObjects[1].activate();
                        }
                    }catch(e){
                        //alert("catch"+(me.tabObjects[2]===JV.Person.activeTabObject));
                        JV.Util.showMessage(JV.Person.Const["CONTACT_SUCCESSFUL"]);
                    }
                }
                var error = $(".jv-dialog-content #jv-selectError");

                if(_type  != "PORTFOLIO"){
                    if( isVarNullOrUndefined(_fileName) && _fileName.trim() != ""){
                        error.html("").removeClass('jv-show').addClass('jv-hide');
                        var extension = _fileName.split('.').pop();
                        if(extension=="pdf" || extension=="txt" ||extension=="doc" ||extension=="docx" ||extension=="rtf" ){
                            var submitSuccessful = JV.Person.submitResumeData( "importFileUploadContent", _contactId, _type, _callback );
                        }
                        else{
                            error.html(JV.Person.Const["UNSUPPORTED_FILE_TYPE"]).removeClass('jv-hide').addClass('jv-show');

                        }
                    }
                    else{
                        error.html(JV.Person.Const["EMPTY_VALUE"]).removeClass('jv-hide').addClass('jv-show');
                    }

                }
                else{
                    if( isVarNullOrUndefined(_fileName) && _fileName.trim() != ""){
                        error.html("").removeClass('jv-show').addClass('jv-hide');
                        var submitSuccessful = JV.Person.submitResumeData( "importFileUploadContent", _contactId, _type, _callback );
                    }
                    else{
                        error.html(JV.Person.Const["EMPTY_VALUE"]).removeClass('jv-hide').addClass('jv-show');
                    }
                }



                if( !submitSuccessful ){
                    //show the error message here.
                    $("#importProgressImage").removeClass('jv-show').addClass('jv-hide');
                    //$(".jv-dialog-content #jv-selectError").html(JV.Person.Const["EMPTY_VALUE"]).removeClass('jv-hide').addClass('jv-show');

                }else{
                    // show the loading state.
                    $("#importProgressImage").removeClass('jv-hide').addClass('jv-show');
                    $(".jv-dialog-content #jv-selectError").removeClass('jv-show').addClass('jv-hide');
                    me.stopProcessingContacts(".jv-importClass");
                }
                break;

            case "sendJobvite":

                var emailId = $("#emailId").attr("value");  //#emailId stores the primary email address of the contact
                var _jvProcessFlag = true;
                if( emailId === undefined || emailId === null || emailId.trim() == ""){
                    _jvProcessFlag = false;
                }
                if( _jvProcessFlag ){
//                  if(_checkDirty == true){
//                      window.location.reload(true);
//                  }
                    JV.Person.sendJobvitesEmail( emailId );
                }else{
                    //Handle the case when contact does not have an email associated with it
                    return false;
                }
                break;


            case "deleteFile":
                var fileId = $(".jv-modalWrapper #jv-fileId").val( );
                if(!!fileId){
                    (this.tabObjects[1]).DeleteFile( fileId );
                }
                JV.Modal.hide( );
                JV.Util.log("deleteFile called");
                //For IE
                var userAgent = window.navigator.userAgent;
                if (userAgent.indexOf("MSIE ") != -1|| !!userAgent.match(/Trident\//)) {
                	document.location.reload();
                }
                break;
        }

    }
}

$(document).ready(function(){
    //id="jv-detailNavigationPrevious"
    if(typeof _contactIds != "undefined"){
        if(JV.CONTACT_IDS == _contactIds[0]){
            $("#jv-detailNavigationPrevious").attr("KEY","");
        }
        if(JV.CONTACT_IDS == _contactIds[_contactIds.length-1]){
            $("#jv-detailNavigationNext").attr("KEY","");
        }
        
        if(_contactIds.length >= 1 && isVarNullOrUndefined(_contactIds[0]) && _contactIds[0].trim()!=""){
            // find the index of the contact in the _contactIds.
            var _id = jvGetQueryParamByName("ids");
            var result = _contactIds.indexOf(_id)
            if(result != -1){
                 $("#jv-paginator").children('span').text( result+1 + ' ' + i18n['FORMTEMPLATE_H_OF'] + ' '+_totalContactIds+ ' '+ i18n['CONTACTS_PAGINATION'])    
            }
            $("#jv-paginator").show();
        }
    }
    
});

// MONOG tasks need to adjust the height of the iframe.
function adjustTasksHeight(height){
    $("#jv-contactTasksTab").find("iframe").css({
        "height":height+"px"
    });
}


JV.FileUploader = (function(){  
    var currentGuid         =   "",
        reset               =   function(){
                                },
        disableInteractions =   function(){
                                    $("textarea#jv-resumeText").attr("readonly", "readonly").addClass('jv-loading');
                                    $("#jv-uploadResume").removeAttr("id").attr("id", "jv-uploadResume-disabled");
                                    $("#jv-pasteResume").removeAttr("id").attr("id", "jv-pasteResume-disabled");
                                 },
        enableInteractions  =   function(){
                                    $("textarea#jv-resumeText").attr("readonly", "").removeClass('jv-loading');
                                    $("#jv-uploadResume-disabled").removeAttr("id").attr("id", "jv-uploadResume");
                                    $("#jv-pasteResume-disabled").removeAttr("id").attr("id", "jv-pasteResume");
                                 },
        bindings            =   function(){
                                    $(document).off('click', '#jv-addContactFrameContainer .canceluploadText').on('click', '#jv-addContactFrameContainer .canceluploadText', function(){
                                        JV.FileUploader.slideContainers();
                                        $("#jv-resumeText").val("");
                                    });
                            
                                    $(document).off('click', 'a.jv-saveAddContact').on('click', 'a.jv-saveAddContact', function(){
                                        JV.FileUploader.saveAttachment({
                                            url     :   JV.SAVE_ATTACHMENT_URL, 
                                            content :   $('textarea#jv-resumeText').val(),
                                            fileKind:   $('select.jv-pasteFileKind').val()
                                        });
                                    });
        
                                    
                                    $(document).off('click', '#jv-uploadResume, #jv-pasteResume').on('click', '#jv-uploadResume, #jv-pasteResume', function(){
                                        JV.FileUploader.slideContainers();
                                    });
                                    
                                    $(document).off('click', "span.canceluploadText", "div.jv-uploadTextResumeSubmit").on('click', "span.canceluploadText", "div.jv-uploadTextResumeSubmit", function(){
                                        $("textarea#jv-resumeText").attr("readonly", "").removeClass("jv-loading").val('');
                                    });                                         
                                };
    
    return {
           init : function(){
               JV.FileUploader.createUploader();
               bindings();
               $( "#progressbar" ).progressbar({
                    value: 5
                });
                $("#progressbar").hide();
           },
           
           guid: function() {
                    function S4() {
                        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
                    }
                    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
                },
                
           createUploader: function(){
                this.fileCount = 0;
                this.currentGuid = this.guid();
                var that = this;
                var uploader = new qq.FileUploader({
                    element: document.getElementById('ajax-uploadContainer'),
                    action: JV.FILE_UPLOAD_URL,
                    sizeLimit:10485760,
                    totalSize: 0,
                    debug: false,
                    currentSizes: {},
                    allowedExtensions: ["txt", "doc", "pdf", "docx", "pages"],
                    multiple:false,
                    params: {
                        sessionGUID: that.currentGuid
                    },
                   showMessage: function(){
                       $("p#fileUploadError").fadeIn(500);
                   },
                        template:'<div class="qq-uploader">\
                                    <div class="jv-acUploadBar">\
                                    <select class="jv-shiftLeft jv-fileKind" style="padding: 2px;margin-right:25px;vertical-align: top;">\
                                        <option value="RESUME">' + i18n['JV_CONTACTDETAILS_UPLOAD_RESUME'] + '</option>\
                                        <option value="COVERLETTER">' + i18n['JV_CONTACTDETAILS_UPLOAD_COVER_LETTER'] + '</option>\
                                        <option value="PORTFOLIO">' + i18n['JV_CONTACTDETAILS_UPLOAD_ATTACHMENT'] + '</option>\
                                    </select>\
                                      <div style="display:inline-block;zoom: 1;*display: inline;" class="qq-upload-button jv-importClass" role="button">'+                                        
                                         '<ul>\
                                            <li class="jvdb-left custom_li"></li>\
                                            <li id="uploadFilesButton" class="jvdb-center custom_li">' + i18n['JV_CONTACTDETAILS_UPLOAD_FILE'] + '</li>\
                                            <li class="jvdb-right custom_li"></li>\
                                         </ul>\
                                      </div>\
                                      <div id="jv-uploadText">\
                                            <p style="font-weight:bold;margin:0px">' + i18n['JV_CONTACTDETAILS_OR_DROP_FILE_HERE_TO_UPLOAD_'] + '</p>\
                                            <span>' + i18n['JV_CONTACTDETAILS_FILE_SHOULD_BE_A_TEXT_PDF_WORD_OR_PAGES_DOCUMENT_'] + '</span>\
                                      </div>\
                                      <div class="jv-uploadList jv-hide">\
                                        <span style="font-weight:bold;color:#565656;">' + i18n['JV_CONTACTDETAILS_UPLOADED_FILE'] + '</span>\
                                        <img class="jv-fileTrash" src="'+JV.IMAGE_TRASH_16_URL+'" alt="' + i18n['JV_CONTACTDETAILS_DELETE'] + '" width="16" height="16" style="float:right;cursor:pointer;"/>\
                                        <ul class="qq-upload-list" style="margin:0;clear:both"></ul>\
                                      </div>\
                                      <div style="min-height:10px;" class="qq-upload-drop-area">\
                                    <span>' + i18n['JV_CONTACTDETAILS_DROP_FILE_HERE_'] + '</span>\
                                  </div>\
                                   </div>\
                                </div>',
    
                        fileTemplate: '<li>' +
                                '<span class="qq-upload-file"></span>' +
                                '<span class="qq-upload-spinner"></span>' +
                                '<span class="qq-upload-size"></span>' +
                                '<a class="qq-upload-cancel" href="#">' + i18n['JV_CONTACTDETAILS_CANCEL'] + '</a>' +
                                '<span class="qq-upload-failed-text">' + i18n['JV_CONTACTDETAILS_FAILED'] + '</span>' +
                        '</li>',
                        onProgress: function(id, fileName, loaded, total){
                        this.currentSizes[id] = loaded;
                        var currProgress = 0;
                        for (var key in this.currentSizes) {
                            currProgress += this.currentSizes[key];
                        }
                        $("#progressbar").progressbar('value', Math.round(currProgress / this.totalSize * 100));
                    },
    
    
                    onSubmit: function(id, fileName){
                        $("p#fileUploadError").fadeOut('500');
                        $(".qq-upload-list").empty();
                        $("#ajax-upload").hide();
                        $("#progressbar").show();
    
                        this.totalSize += uploader._handler.getSize(id);
                    },
    
                    onComplete: function(id, fileName, responseJSON){
                        var isIE = navigator.userAgent.indexOf("MSIE") !== -1 || !!document.documentMode;
                        if (isIE) {
                            $("#progressbar").progressbar('value', 100);
                        }
                        that.fileName = fileName;
//                      JV.Person.process('uploadFileForm', '', null);
                        that.saveAttachment({fileName : fileName, url :JV.SAVE_ATTACHMENT_URL, fileKind:$('select.jv-fileKind').val()});
                    }
                });
            },
            
            saveAttachment: function(options) {
                options = $.extend({
                    url : JV.SAVE_ATTACHMENT_URL,
                    options: $('select.jv-fileKind').val()
                }, options);

                var that = this,
                args = {},
                data = {};

                if(options.content){
                    data.resumeTxt = options.content;
                    if(options.fileKind === JV.Person.Const['RESUME'] && $("#jv-mergePasteDetails").prop("checked")){
                        data.mergeDetails = true;
                    }
                }else{
                    data.fileName    = options.fileName;
                    data.sessionGUID = this.currentGuid;
                    if(options.fileKind === JV.Person.Const['RESUME'] && $("#jv-mergeDetails").prop("checked")){
                        data.mergeDetails = true;
                    }
                }
               
                args.url = options.url+'&ids='+$('input#ids').val()+'&kind='+options.fileKind;
                args.data = data;
                args.ajaxType = i18n["JV_CONTACTDETAILS_UPLOAD_ATTACHMENT"];
                args.success = function (response){
                    response = JSON.parse( response );
                    //contactChangeLog has information regarding contact details that changed or got added after uploading the resume
                    var contactChangeLog = response.contactChangeLog; //TODO: Display this in the modal
                    (JV.Person.tabObjects[1]).setDirty(true);
                    if(isVarNullOrUndefined(contactChangeLog) && Object.keys(contactChangeLog).length > 0){
                        var detailsChanged = JV.Person.detailsChanged(contactChangeLog);
                        if(contactChangeLog.nameUpdated && contactChangeLog.nameUpdated == true && response.name) {
                            /* As a result of merging details from resume to contact, the name might have changed.
                             * To avoid refresing of the whole page, just updating the name of the contact shown in the breadcrumb 
                             * Clicking on the details tab will fetch the new information for contact details.
                            */
                            $("#CRMBreadCrumb").text(response.name);
                        }
                        if(detailsChanged) {
                            //Setting the details tab dirty flag as true beacuse contact details need to refreshed with new information
                            (JV.Person.tabObjects[0]).setDirty(false);
                            (JV.Person.tabObjects[0]).setResumeUpload(true);
                            JV.Modal.show($("#jv-mergeResults").html(),false);
                        }
                    } 
                    else {
                        JV.Util.showMessage(response.confirmationMessage);
                    }
                    if (JV.Person.tabObjects[1] === JV.Person.activeTabObject) {
                        JV.Person.tabObjects[1].activate();
                    } 
                    enableInteractions();
                };
                args.error = function (response) {
                    JV.Util.showMessage(i18n['JV_FILE_ERROR']);
                    (JV.Person.tabObjects[1]).setDirty(true);
                    if (JV.Person.tabObjects[1] === JV.Person.activeTabObject) {
                        JV.Person.tabObjects[1].activate();
                    } 
                    enableInteractions();
                };
                disableInteractions();
                JV.Util.makeAjaxRequest(args);
            },
            
            slideContainers: function(){
                var $ajaxUpload = $('#ajax-upload'),
                    $pasteResumeContainer = $('#jv-pasteResumeContainer'),
                    $uploadResume = $("#jv-uploadResume"),
                    $pasteResume = $("#jv-pasteResume"),
                    me = this;

                reset();
                $("p#fileUploadError").hide();
                if($ajaxUpload.is(':visible')){
                    $ajaxUpload.css('width', $ajaxUpload.width());
                    $ajaxUpload.slideUp(function(){
                        $uploadResume.addClass(plusSign).removeClass(minusSign);
                    });
                    $pasteResumeContainer.slideDown(function(){
                        $pasteResume.addClass(minusSign).removeClass(plusSign);
                    });
                }else{
                    $pasteResumeContainer.slideUp(function(){
                        $pasteResume.addClass(plusSign).removeClass(minusSign);
                    });
                    $ajaxUpload.slideDown(function(){
                        $uploadResume.addClass(minusSign).removeClass(plusSign);
                    });
                }
            }
            
    };
}());

window.adjustTasksHeight = window.adjustTasksHeight || adjustTasksHeight;
window.toggleAccordionIcon = window.toggleAccordionIcon || toggleAccordionIcon;
window.expandAllAccordion = window.expandAllAccordion || expandAllAccordion;
window.closeAllAccordion = window.closeAllAccordion || closeAllAccordion;
window.DetailsTab = window.DetailsTab || DetailsTab;